import { useEffect } from 'react';

/**
 * Component to add noindex meta tags to admin pages
 * Prevents search engines from indexing sensitive admin areas
 */
export const NoIndex = () => {
  useEffect(() => {
    // Add noindex meta tag
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Add X-Robots-Tag equivalent
    const metaGooglebot = document.createElement('meta');
    metaGooglebot.name = 'googlebot';
    metaGooglebot.content = 'noindex, nofollow';
    document.head.appendChild(metaGooglebot);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(metaRobots);
      document.head.removeChild(metaGooglebot);
    };
  }, []);

  return null;
};

export default NoIndex;
